import { Base } from './_base';
import get from 'lodash-es/get';
import { EntryPointBackend } from '@autoinformer/models/worksheet-actions/backend/entry-point';
import { merge_by_template } from '@shared/helpers/collections';

export class EntryPointFrontend extends Base {
  constructor(item) {
    super(item);
    this.type = 'start';

    this.data = merge_by_template(item.data || {}, {
      params: {
        number_id: null
      },
      options: {
        next: null
      }
    });
  }

  isAllowedIncomingConnection() {
    return false;
  }

  toBackend() {
    const base_transform = super.toBaseBackend();

    const params = get(base_transform, 'data.params', {});
    const options = get(base_transform, 'data.options', {});

    const options_transform = {
      action_id: options.next || null,
      data: { options } || {}
    };

    return new EntryPointBackend({
      ...base_transform,
      ...options_transform,
      ...params
    });
  }
}
